import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import { fetchUsuario, getUsuario } from '../Components/user';
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import SinPermisos from '../Components/SinPermisos/SinPermisos';
export default function MainLayout() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario(); // Llama a la función para obtener datos del usuario
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    const rolesPrivados = ['admin', 'colaborador', 'mesero-chef'];
    const tieneAccesoPrivado = rolesPrivados.includes(usuarioLegued?.rol);

    return (
        <div>
            <TitleMeta />
            {loading ? (
                <Spiner />
            ) : usuarioLegued?.idUsuario ? (
                tieneAccesoPrivado ? <Outlet /> : <SinPermisos />
            ) : (
                <Auth />
            )}
        </div>
    );
}
